import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "yana-privacy-ack-v1";

export default function PrivacyBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // Delay to avoid layout jump on first paint
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      /* localStorage blocked — never show */
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="privacy-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 lg:right-auto lg:max-w-md z-50 animate-in"
      role="region"
      aria-label="Privacy notice"
    >
      <div className="bg-ink text-linen border border-white/10 p-5 shadow-xl">
        <p className="text-sm leading-relaxed">
          This site collects only the data you send us — contact messages, newsletter signups, story submissions. No tracking cookies, no analytics, no ads.{" "}
          <Link
            to="/privacy"
            className="text-ember hover:text-linen underline underline-offset-4"
            onClick={dismiss}
          >
            Read the plain-English privacy notice
          </Link>
          .
        </p>
        <button
          type="button"
          data-testid="privacy-banner-dismiss"
          onClick={dismiss}
          className="mt-4 bg-ember text-ink px-4 py-2 text-xs font-accent font-semibold tracking-wide hover:bg-ember/90 transition-colors"
        >
          Understood
        </button>
      </div>
    </div>
  );
}
